import React from 'react';
import './TicketPrices.css';
import tableSponsorshipPDF from '../pages/images/lp/sponsorFlyer.pdf'; // Adjust the path to your PDF
import { Link } from 'react-router-dom';

const TicketPrices = () => {
  const tickets = [
    { type: 'General Admission', price: '$125.00', fee: '$10.23 Fee' },
    { type: 'Table Sponsorship (8 seats, preferred location)', price: '$1,500.00', fee: '', pdf: tableSponsorshipPDF },
  ];

  return (
    <div className="ticket-container">
      {/* <h2>Tickets</h2> */}
      <div className="ticket-header">
        {/* <h2>Tickets</h2> */}
        <p className="ticket-alt-purchase">
          To purchase tickets or table sponsorship by another method, please call<br /> <strong>(806) 239-8979</strong>
        </p>
      </div>
      <ul className="ticket-list">
        {tickets.map((ticket, index) => (
          <li key={index} className="ticket-item">
            <div className="ticket-info">
              <div className="ticket-type">{ticket.type}</div>
              <div className="ticket-price">{ticket.price}</div>
              {/* {ticket.fee && <div className="ticket-fee">{ticket.fee}</div>} */}
              {ticket.pdf && (
                <div className="ticket-pdf">
                  {/* <a href={ticket.pdf} target="_blank" rel="noopener noreferrer">
                    Download Form
                  </a>
                  <p>Please return the form to <a href="mailto:jimmydeanfest@gmail.com">jimmydeanfest@gmail.com</a></p> */}
                </div>
              )}
            </div>
            <Link to="https://www.eventbrite.com/e/jimmy-dean-music-festival-2026-tickets-1981466595928?aff=oddtdtcreator" className='purchase-button'>Purchase</Link>
            {/* <button className="purchase-button">Purchase</button> */}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TicketPrices;

